import { useLocation } from 'react-router-dom';
import { resolveClientRouteMeta } from '@shared/seo/seoMeta';
import { useDocumentHead } from '../seo/useDocumentHead';

/**
 * Mounted once inside the Router context to keep the document head correct
 * during client-side SPA navigation for every non-song route (home, each
 * mode home / tutorial / browse page, and the noindex utility routes).
 *
 * Song play pages own their own head — they know the loaded chart's real
 * title — so {@link resolveClientRouteMeta} returns `null` for
 * `/${mode}/play/:slug` and this component no-ops there, deferring to the
 * play page's own {@link useDocumentHead} call. Renders nothing.
 */
export function RouteHead(): null {
  const { pathname } = useLocation();
  useDocumentHead(resolveClientRouteMeta(pathname));
  return null;
}
